var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.92 24.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set_of_64_UI_Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.06,2.86c-3.82-3.82-9.9-3.82-13.72,0-3.25,3.13-3.72,8.09-1.45,11.85-.12,.08-.24,.17-.35,.28L.62,20.92c-.82,.82-.82,2.16,0,2.98,.82,.82,2.16,.82,2.98,0l5.92-5.92c.08-.08,.14-.16,.2-.25,3.79,2.62,8.95,2.24,12.34-1.14,3.82-3.82,3.82-9.9,0-13.72Zm-1.41,12.3c-2.97,2.97-7.85,3.04-10.89,0s-3.04-7.85,0-10.89c3.04-3.04,7.85-3.04,10.89,0,2.97,2.97,3.04,7.85,0,10.89Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8df7b2ea086f2d5d46665e2b2518e455.svg";
export { ForwardRef as ReactComponent };